// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import { HeaderContent } from '../components/Header/HeaderContent';

interface ILocation {
  pageName: string;
}
export const AppSettingsLayout: React.FC = () => {
  const nav = useNavigate();
  const location = useLocation();
  const state = location.state as ILocation;
  const onBack = () => {
    if (!state?.pageName) {
      nav('/');
      return;
    }
    nav(-1);
  };
  return (
    <Box sx={{ p: 3 }}>
      <AppBar elevation={0}>
        <Toolbar>
          <IconButton onClick={onBack}>
            <ChevronLeft />
          </IconButton>
          <Typography variant="h5">{state?.pageName || 'Settings'}</Typography>
          <HeaderContent />
        </Toolbar>
      </AppBar>
      <Outlet />
    </Box>
  );
};
